/** Full backend URL from REACT_APP_API_BASE_URL (e.g. http://localhost:8000/api). */


export const API_CONFIG = {
  BASE_URL: process.env.REACT_APP_API_BASE_URL,
  ASSET_BASE_URL:process.env.REACT_APP_ASSET_URL,
  TIMEOUT: 50000,

  ENDPOINTS: {
    AUTH: {
      LOGIN: "/adminLogin",
      VERIFY: "/verifyMe",
      CHANGE_PASSWORD: "/changePassword",
    },

    DASHBOARD: { STATS: "/getDashboardstatices" },

    LOOKUPS: {
      ROLES: "/getRolesForuserAdd",
      CENTRES: "/getCentresLookup",
    },

    USERS: {
      LIST: "/getAllUsers",
      COUNT: "/getAllUsersCount",
      DETAIL: "/getUserWithid",
      CREATE: "/createNewUser",
      UPDATE: "/updateUser",
      DELETE: "/deleteUser",
    },

    ROLES: {
      LIST: "/getRolesList",
      DETAIL: "/getRoleById",
      CREATE: "/createRole",
      UPDATE: "/updateRole",
      DELETE: "/deleteRole",
      MODULES_WITH_PERMS: "/getRoleModulesWithPermissions",
      SAVE_PERMISSIONS: "/saveRolePermissions",
      MY_PERMISSIONS: "/getMyPermissions",
    },

    ACTIVITY: {
      LIST: "/getActivityLogs",
      COUNT: "/getActivityLogsCount",
      MARK_READ: "/markNotificationsRead",
      MARK_ALL_READ: "/markAllNotificationsRead",
    },

    CENTRES: {
      LIST: "/getCentresList",
      DETAIL: "/getCentreById",
      CREATE: "/createCentre",
      UPDATE: "/updateCentre",
      UPDATE_STATUS: "/updateCentreStatus",
      DELETE: "/deleteCentre",
    },

    REGISTRATIONS: {
      LIST: "/getRegistrationsList",
      DETAIL: "/getRegistrationById",
      APPROVE: "/approveRegistration",
      REJECT: "/rejectRegistration",
      RESEND: "/resendApproval",
    },

    FAMILIES: {
      LIST: "/getFamiliesList",
      DETAIL: "/getFamilyById",
      UPDATE: "/updateFamily",
      UPDATE_STATUS: "/updateFamilyStatus",
      RESET_LINK: "/sendFamilyResetLink",
      DELETE: "/deleteFamily",
    },

    CHILDREN: {
      LIST: "/getChildrenList",
      DETAIL: "/getChildById",
      CREATE: "/createChild",
      UPDATE: "/updateChild",
      DELETE: "/deleteChild",
    },

    FORMS: {
      LIST: "/getFormsList",
      DETAIL: "/getFormById",
      UPDATE: "/updateForm",
      UPDATE_STATUS: "/updateFormStatus",
    },

    SUBMISSIONS: {
      LIST: "/getSubmissionsList",
      DETAIL: "/getSubmissionById",
      UPDATE_STATUS: "/updateSubmissionStatus",
    },

    DOCUMENTS: {
      LIST: "/getDocumentsList",
      DETAIL: "/getDocumentById",
      CREATE: "/createDocument",
      UPDATE: "/updateDocument",
      UPDATE_STATUS: "/updateDocumentStatus",
      DELETE: "/deleteDocument",
    },

    POLICIES: {
      LIST: "/getPoliciesList",
      DETAIL: "/getPolicyById",
      CREATE: "/createPolicy",
      UPDATE: "/updatePolicy",
      UPDATE_STATUS: "/updatePolicyStatus",
      DELETE: "/deletePolicy",
    },

    HANDBOOK: {
      LIST: "/getHandbookList",
      DETAIL: "/getHandbookById",
      CREATE: "/createHandbook",
      UPDATE: "/updateHandbook",
      DELETE: "/deleteHandbook",
    },

    SETTINGS: {
      GET: "/getSettings",
      SAVE: "/saveSettings",
    },
  },

  PAGINATION: {
    DEFAULT_LIMIT: 15,
    PAGE_SIZES: [15, 25, 50, 100],
  },
};
